export const portfolioData = [
    {
        id: 1,
        title: "Payment Gateway",
        description: "Sistem integrasi pembayaran terpusat yang mendukung berbagai metode transaksi secara aman dan otomatis.",
        image: require("@/assets/img/1.jpg"),
        demoLink: "https://pay.affidev.com"
    },
    {
        id: 2,
        title: "WhatsApp Gateway",
        description: "Layanan API WhatsApp yang handal untuk otomatisasi pesan, notifikasi sistem, dan layanan pelanggan.",
        image: require("@/assets/img/2.jpg"),
        demoLink: "https://bot.affidev.com"
    },
    {
        id: 3,
        title: "Digital Wedding SAAS",
        description: "Solusi Software as a Service untuk membuat undangan pernikahan digital yang elegan dan interaktif.",
        image: require("@/assets/img/3.jpg"),
        demoLink: "https://indovite.com"
    },
    {
        id: 4,
        title: "Online Store",
        description: "Website e-commerce modern dengan fitur katalog produk, keranjang belanja, dan sistem checkout terpadu.",
        image: require("@/assets/img/4.jpg"),
        demoLink: "https://store.affidev.com"
    },
    {
        id: 5,
        title: "Plagiarisme Coding Checker",
        description: "Tools analisis kode cerdas untuk mendeteksi kemiripan logika dan menjaga integritas source code.",
        image: require("@/assets/img/5.jpg"),
        demoLink: "https://pastecheck.com"
    },
    {
        id: 6,
        title: "Iqrafun Course",
        description: "Platform pembelajaran interaktif yang dirancang untuk memudahkan akses pendidikan agama kapan saja.",
        image: require("@/assets/img/6.jpg"),
        demoLink: "https://iqrafun.com"
    }
];
